// Core & Vendor Packages
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Form, Image, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

// Components
import FormText from 'components/GlobalUIs/FormText';
import ButtonSubmit from 'components/GlobalUIs/ButtonSubmit';
import FormCheckBox from 'components/GlobalUIs/FormCheckBox';
import { login, selectAuth, setIsAuthenticated } from 'reducers/authReducer';

// Assets
import styles from './index.module.scss';
import LoginImage from 'assets/images/login Image.png';
import { ReactComponent as UserSVG } from 'assets/svg/username.svg';
import { ReactComponent as LockSVG } from 'assets/svg/lock.svg';

const initialState = {
  password: '',
  emailAddress: '',
  rememberMe: false,
};

// Main Component
const Login = () => {
  const dispatch = useDispatch();

  // const navigate = useNavigate();

  const authState = useSelector(selectAuth);
  const { loginLogs, userInfo } = authState;

  const [formData, setFormData] = useState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();

    const params = {
      username: formData?.emailAddress,
      password: formData?.password,
    };

    dispatch(login(params));
  };

  const emailProps = {
    Icon: UserSVG,
    haveClass: '',
    required: true,
    haveIcon: true,
    type: 'email',
    name: 'Email Address',
    setState: setFormData,
    placeholder: 'Enter your email',
    stateValue: formData?.emailAddress,
  };

  const passwordProps = {
    Icon: LockSVG,
    required: true,
    haveIcon: true,
    type: 'password',
    name: 'Password',
    setState: setFormData,
    placeholder: 'Enter your password',
    stateValue: formData?.password,
  };

  const rememberMeProps = {
    name: 'rememberMe',
    text: 'Remember me',
    setState: setFormData,
    haveClass: styles?.rememberMe,
    stateValue: formData?.rememberMe,
  };

  const submitButtonProps = {
    type: 'submit',
    value: 'Log in',
    variant: 'primary',
    className: styles?.submitButton,
    isDisabled: loginLogs?.isLoading,
  };

  renderSubmitCallback(loginLogs, userInfo, dispatch);

  useEffect(() => {
    console.log('loginLogs', loginLogs);
  }, [loginLogs]);

  return (
    <Container fluid>
      <div className={styles?.loginContainer}>
        <Form className={styles?.loginForm} onSubmit={handleSubmit}>
          <div className={styles?.loginHeader}>
            <h6>Welcome!</h6>
            <p>Log in</p>
          </div>

          <div className={styles?.formContainer}>
            <FormText {...emailProps} />

            <FormText {...passwordProps} />
          </div>

          <div className={`${styles?.formContainer} ${styles?.formHorizontal}`}>
            <FormCheckBox {...rememberMeProps} />

            <Link className={styles?.forgotPassword} to='/account-recovery'>
              Forgot Password?
            </Link>
          </div>

          <div className={styles?.marginContainer}>
            <ButtonSubmit {...submitButtonProps} />

            <div className={styles?.signup}>
              <p>Don&apos;t have an account?</p>

              <Link className={styles?.link} to='/sign-up'>
                Sign Up
              </Link>
            </div>
          </div>

          <p className={styles?.copyright}>
            2023 © Concepcion Municipal Inventory. All Rights Reserved.
          </p>
        </Form>

        <div className={styles.imageContainer}>
          <Image src={LoginImage} />
        </div>
      </div>
    </Container>
  );
};

const renderSubmitCallback = (loginLogs, userInfo, dispatch) => {
  useEffect(() => {
    const { error, isFailed, isSuccess } = loginLogs;

    if (isSuccess) {
      // eslint-disable-next-line no-unreachable
      console.log('running');
      dispatch(setIsAuthenticated());
    }

    if (isFailed) {
      toast.error(error);
    }
  }, [loginLogs]);
};

export default Login;
